import React from 'react';
import IndustryPageTemplate from '../../components/IndustryPageTemplate';
import SEO from '../../components/SEO';

const TattooShop = () => {
  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [
      {
        "@type": "Question",
        "name": "How can Local Business Heroes help my tattoo shop business?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Local Business Heroes helps tattoo shop businesses capture more leads, automate follow-ups, reduce no-shows, and grow faster. Rated 4.9/5 by 1,200+ UK businesses."
        }
      },
      {
        "@type": "Question",
        "name": "How much does it cost for tattoo shop businesses?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Plans start at £297/month with a 14-day trial for just £5. Most tattoo shop businesses see ROI within the first month."
        }
      },
      {
        "@type": "Question",
        "name": "Do I need technical skills to use it?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "No. Local Business Heroes is designed for busy business owners with zero tech experience. Setup takes 5 minutes with UK-based support."
        }
      },
      {
        "@type": "Question",
        "name": "Will it work for my tattoo shop business?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Yes. Local Business Heroes is specifically designed for local service businesses like tattoo shop. Features include appointment scheduling, automated reminders, lead capture, and customer management."
        }
      }
    ]
  };

  const localBusinessSchema = {
    "@context": "https://schema.org",
    "@type": "SoftwareApplication",
    "name": "CRM for Tattoo Shop - Local Business Heroes",
    "applicationCategory": "BusinessApplication",
    "offers": {
      "@type": "Offer",
      "price": "297",
      "priceCurrency": "GBP"
    },
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "4.9",
      "reviewCount": "1200"
    }
  };

  const breadcrumbs = [
    { name: "Home", url: "/" },
    { name: "Industries", url: "/industries" },
    { name: "Tattoo Shop CRM", url: "/industries/tattoo-shop" }
  ];

  const industryData = {
    name: 'Tattoo Shop',
    title: 'Book More Sessions & Build a Loyal Client Base',
    subtitle: 'Capture consultations instantly, manage multi-session projects, and get clients to return for new work',
    icon: '🎨',
    challenges: [
      'Missing consultation requests',
      'Clients ghost after initial contact',
      'Hard to schedule multi-session pieces',
      'Touch-up reminders are forgotten',
      'Difficult to showcase portfolio'
    ],
    solutions: [
      'Instant consultation capture',
      'Automated follow-up sequences',
      'Multi-session project management',
      'Touch-up reminder automation',
      'Digital portfolio sharing'
    ],
    features: [
      'Client CRM with tattoo history',
      'Online consultation booking',
      'Portfolio gallery',
      'Multi-session tracking',
      'Touch-up reminders',
      'Deposit management',
      'Aftercare instructions',
      'Review automation'
    ],
    results: [
      '65% consultation conversion',
      'Book 8+ weeks in advance',
      '80% return for additional work',
      '£7.1K average monthly revenue increase'
    ]
  };

  return (
    <>
      <SEO 
        title="CRM for Tattoo Shop UK | Marketing Automation | Local Business Heroes"
        description="Rated 4.9/5. CRM and marketing automation for tattoo shop businesses. Capture more leads, automate follow-up, grow faster. Start £5 trial today."
        keywords="CRM for tattoo shop UK, tattoo shop business software, tattoo shop customer management, tattoo shop lead generation UK"
        url="/industries/tattoo-shop"
        schemaMarkup={[faqSchema, localBusinessSchema]}
        breadcrumbs={breadcrumbs}
      />
      <IndustryPageTemplate industry={industryData} />
    </>
  );
};

export default TattooShop;